import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router-dom";

import { RootState } from "../../../store";
import { IUser } from "../../auth/reducers";
import { ITeamMember } from "../../myTeam/reducers";
import { getServicesAgendaTeam } from "../../serviceOrdering/actions";
import { IService } from "../../serviceOrdering/reducers";
import AgendaComponent from "../components/AgendaComponent";
import { AgendaRange } from "../reducers";

const mapStateToProps = (state: RootState) => {
  const services: IService[] = state.serviceOrderingReducer.servicesAgendaTeam;
  const teamMembers: ITeamMember[] = state.teamReducer.operators;
  const user: IUser = state.authReducer.user;
  const rangeData: AgendaRange = state.agendaReducer;

  return {
    rangeData,
    services,
    teamMembers,
    user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getServicesAgendaTeam: (
      startDate: string,
      endDate: string,
      agencyId: string,
    ) => {
      return new Promise((resolve, reject) => {
        dispatch(
          getServicesAgendaTeam(startDate, endDate, resolve, reject, agencyId),
        );
      });
    },
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxAgenda = ConnectedProps<typeof connector>;

export default withRouter(connector(AgendaComponent));
